import { useIntl } from 'react-intl';

import { TextDocument } from '@sorare/core/src/routing/TextDocument/lazy';

import { InfoLayout } from '#src/components/layouts/InfoLayout.tsx';

const LegalPolicy = () => {
  const { formatMessage } = useIntl();
  return (
    <InfoLayout>
      <TextDocument
        document={formatMessage({
          id: 'LegalNotice.path',
          defaultMessage: 'LEGAL_NOTICE.md',
        })}
      />
    </InfoLayout>
  );
};

export default LegalPolicy;
